// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3560":"c9b3772c","8353":"00731c10","8355":"03f55591","8977":"d9220130","9537":"1ca18c6b"}[chunkId] + ".chunk.css";
};